export default {
  init() {
  },
};

$(window).on('load resize', function(){
  if ($(window).width() >= 992) {
    $('.mega-sub-menu .mega-menu-column:not(:first-child)').each(function() {
      $('.mega-menu-item', this).each(function(index) {
        $(this).addClass(`mega-menu-item-${index}`);
      })
    })
  
    $('.mega-equalised-submenu').each(function() {
      let items = $('.mega-menu-item', this).length;
      let thisMegamenu = $(this);
      
      for (let i = 0; i < items; i++) {
        let maxHeight = 0;

        // Remove added inline style on resize so the function can recalculate it fresh
        thisMegamenu.find(`.mega-menu-item-${i}`).each(function() {
          $('a', this).removeAttr('style')
        })
  
        thisMegamenu.find(`.mega-menu-item-${i}`).each(function() {
          if ($('a', this).height() > maxHeight) {
            maxHeight = $('a', this).height();
          }
        })
  
        thisMegamenu.find(`.mega-menu-item-${i}`).each(function() {
          $('a', this).height(maxHeight)
        })
      }
    })
  }

  if ($(window).width() < 992) {
    $('.mega-equalised-submenu').each(function() {
      let items = $('.mega-menu-item', this).length;
      let thisMegamenu = $(this);

      for (let i = 0; i < items; i++) {
        thisMegamenu.find(`.mega-menu-item-${i}`).each(function() {
          $('a', this).removeAttr('style')
        })
      }
    })
  }
});



// WEBPACK FOOTER //
// ./scripts/routes/megamenu.js